import { formatDateTime, formatNaira } from "./format";
import type { Transaction } from "../types";

const CREDIT_ICON =
  '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 4v16m0-16l-5 5m5-5l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const DEBIT_ICON =
  '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 20V4m0 16l-5-5m5 5l5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const TYPE_LABEL: Record<Transaction["type"], string> = {
  wallet_funding: "Wallet Funding",
  wallet_withdrawal: "Wallet Withdrawal",
  electricity_purchase: "Electricity Purchase",
  bill_payment: "Bill Payment",
  shop_payment: "Estate Marketplace",
};

export function renderTransactionList(container: HTMLElement, transactions: Transaction[], loading = false): void {
  container.innerHTML = "";

  if (transactions.length === 0) {
    const empty = document.createElement("li");
    empty.className = loading ? "ledger-empty ledger-empty--loading" : "ledger-empty";
    empty.textContent = loading ? "Loading\u2026" : "No transactions yet.";
    container.appendChild(empty);
    return;
  }

  transactions.forEach((tx) => {
    const row = document.createElement("li");
    row.className = "ledger-row";
    const isCredit = tx.direction === "credit";
    const statusBadge =
      tx.status === "success"
        ? ""
        : `<span class="ledger-status ledger-status--${tx.status}">${tx.status}</span>`;
    const metaBits = [formatDateTime(tx.createdAt)];
    if (tx.meterSerial) metaBits.push(tx.meterSerial);
    if (tx.units) metaBits.push(tx.units);

    row.innerHTML = `
      <span class="ledger-icon ${isCredit ? "ledger-icon--credit" : "ledger-icon--debit"}">${isCredit ? CREDIT_ICON : DEBIT_ICON}</span>
      <div class="ledger-main">
        <div class="ledger-desc">${tx.description || TYPE_LABEL[tx.type]} ${statusBadge}</div>
        <div class="ledger-meta">${metaBits.join(" \u00b7 ")}</div>
      </div>
      <div class="ledger-amount ${isCredit ? "ledger-amount--credit" : "ledger-amount--debit"}">${isCredit ? "+" : "\u2212"}\u20a6${formatNaira(tx.amountKobo)}</div>
    `;
    container.appendChild(row);
  });
}
